export default __webpack_public_path__ + "static/media/cockpit.bf8ee29e.jpeg";